module.exports = __webpack_public_path__ + "static/media/Type_Null_gaussian2.729d2278.png";